import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/v2/watermark-editor-batch'
  },
  {
    path: '/v1',
    component: { render: (e) => e("router-view") },
    children: [
      {
        path: 'watermark-editor-batch',
        name: 'WatermarkEditorBatch',
        component: () => import('@/views/v1/WatermarkEditorBatch.vue')
      },
      {
        path: 'combine',
        name: 'Combine',
        component: () => import('@/views/v1/Combine.vue')
      }
    ]
  },
  {
    path: '/v2',
    component: { render: (e) => e("router-view") },
    children: [
      {
        path: 'watermark-editor-batch',
        name: 'WatermarkEditorBatchV2',
        component: () => import('@/views/v2/WatermarkEditorBatch.vue')
      },
      {
        path: 'combine',
        name: 'CombineV2',
        component: () => import('@/views/v2/Combine.vue')
      },
      {
        path: 'aIMaterialGeneration',
        name: 'aIMaterialGeneration',
        component: () => import('@/views/v2/aIMaterialGeneration.vue')
      },
      {
        path: 'ModelConfig',
        name: 'ModelConfig',
        component: () => import('@/views/v2/ModelConfig.vue')
      },
      {
        path: 'aIgcV2MaterialGeneration',
        name: 'aIgcV2MaterialGeneration',
        component: () => import('@/views/v2/aIgcV2MaterialGeneration.vue')
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
